import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/[locale]/(docs)/components/DocsNavigationMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderToc"] */ "/opt/build/repo/app/[locale]/(docs)/components/DocsRenderToc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/[locale]/(docs)/components/LocaleSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/[locale]/(website)/components/icons/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/[locale]/(website)/components/ThemeSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Trigger","Content"] */ "/opt/build/repo/node_modules/@radix-ui/react-collapsible/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
